/* @flow */
import React, { useState, useCallback } from 'react'
import ErrorSvg from '@website/common/assets/error-circle.svg'
import WarningSvg from '@website/common/assets/warning-circle.svg'

import * as S from './RenderforestFooter.styled'
import meta from './RenderforestFooter.meta'
import Popup from './Popup'
import FormContent from './FormContent'
import ErrorContent from './ErrorContent'
import SuccessContent from './SuccessContent'



const RenderforestFooter = ({}) => {
  const [isComplaintPopupOpen, setComplaintPopupState] = useState(false)
  const [errorTitle, setErrorTitle] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [errorIcon, setErrorIcon] = useState('')
  const [isSuccessPopupOpen, setSuccessPopupState] = useState(false)

  const openComplaintPopup = useCallback(() => {
    setComplaintPopupState(true)
  }, [])

  const closeComplaintPopup = useCallback(() => {
    setComplaintPopupState(false)
  }, [])

  const openSuccessPopup = useCallback(() => {
    setSuccessPopupState(true)
  }, [])

  const closeSuccessPopup = useCallback(() => {
    setSuccessPopupState(false)
  }, [])

  const onError = useCallback((message, status) => {
    setErrorMessage(message || 'Please refresh page to load data')
    setErrorTitle(
      status === 403 ? 'Thanks for the report!' : 'Something went wrong'
    )
    setErrorIcon(status === 403 ? WarningSvg : ErrorSvg)
  }, [])

  const closeErrorPopup = useCallback(() => {
    setErrorMessage('')
  }, [])



  return (
    <>
      <S.WMCustomContainer id="footer">
        <S.LeftContent>
          <S.LogoWrapper>
            <img alt="Logo" src="https://static.rfstat.com/renderforest/images/website_maker_images/renderforest_logo-2.svg" />
          </S.LogoWrapper>
          <S.Text>
            Disclaimer: This website was created using Renderforest, but it <S.Bold> is not operated or monitored by Renderforest. </S.Bold> If you come across any abusive, inappropriate, or scam-related content, please report it immediately.
          </S.Text>
        </S.LeftContent>
        <S.Button type="primary" onClick={openComplaintPopup}>
          Report
        </S.Button>
      </S.WMCustomContainer>
      {isComplaintPopupOpen && (
        <Popup onClose={closeComplaintPopup}>
          <FormContent
            onClose={closeComplaintPopup}
            onSuccess={openSuccessPopup}
            onError={onError}
          />
        </Popup>
      )}
      {isSuccessPopupOpen && (
        <Popup
          onClose={closeSuccessPopup}
          style={{ maxWidth: '400px', zIndex: 20 }}
        >
          <SuccessContent />
        </Popup>
      )}
      {errorMessage && (
        <Popup onClose={closeErrorPopup} style={{ maxWidth: '400px' }}>
          <ErrorContent
            message={errorMessage}
            icon={errorIcon}
            title={errorTitle}
          />
        </Popup>
      )}
    </>
  )
}

RenderforestFooter.meta = meta

export default RenderforestFooter
